import { render, staticRenderFns } from "./combos.vue?vue&type=template&id=08421eb2&"
import script from "./combos.vue?vue&type=script&lang=js&"
export * from "./combos.vue?vue&type=script&lang=js&"
import style0 from "./combos.vue?vue&type=style&index=0&id=08421eb2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports